import type { DocumentAssemblerGenerationStatus } from '@commenda/api';
import { Badge } from '@commenda/kakashi';

import { DocumentAssemblerHelper } from './DocumentAssemblerHelper';

interface DocumentAssemblerGenerationStatusBadgeProps {
  status: DocumentAssemblerGenerationStatus;
}

export const DocumentAssemblerGenerationStatusBadge = ({
  status,
}: DocumentAssemblerGenerationStatusBadgeProps) => {
  const badge = DocumentAssemblerHelper.getGenerationStatusBadge(status);

  return (
    <Badge variant={badge.variant} hasDot>
      {badge.label}
    </Badge>
  );
};
